import React, { memo } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';
import { unwrap } from '../../../utils/ChangeSpy';
import { IconButton } from '../../helpers/IconButton';

const BroadComponent = ({ data, businessModels, deprecatedIndustries, onClick, headerClass, disabled }) => {
  let rows = [];
  let deprecatedRows = [];
  const industries = unwrap(data) || List();
  const models = unwrap(businessModels) || List();
  const realData = models.concat(industries);

  if (realData.size) {
    rows = realData.map(t => {
      const cssClass = classNames({ deleted: t.get('deletedAt') });

      return (
        <tr key={`${t.get('id')}${t.get('category')}`} className={cssClass}>
          <td>
            <span>{t.get('category')}</span>
          </td>
        </tr>
      );
    });
  }

  if (deprecatedIndustries.size) {
    deprecatedRows = deprecatedIndustries.map(t => {
      const cssClass = classNames('text-danger', {
        deleted: t.get('deletedAt'),
      });

      return (
        <tr key={`${t.getIn(['id', 'value'])}${t.getIn(['industryLabel', 'value'])}`} className={cssClass}>
          <td>
            <span>{t.getIn(['industryLabel', 'value'])}</span>
          </td>
        </tr>
      );
    });
  }

  if (rows.length === 0 && deprecatedRows.length === 0) {
    rows.push(
      <tr key="norow">
        <td>No rows to display</td>
      </tr>,
    );
  }

  const handleClick = () => {
    if (!disabled) {
      return onClick();
    }
  };

  return (
    <table className="table table table-bordered table-hover empty-table">
      <thead>
        <tr>
          <th className="plus-icon">
            <div className={`d-flex ${headerClass}`}>
              <IconButton
                disabled={disabled}
                icon="plus"
                onClick={handleClick}
                size="sm"
                title="Add"
                variant="primary"
              />
              <span>Industries</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows}
        {deprecatedRows}
      </tbody>
    </table>
  );
};

/** Broad component. */
export const Broad = memo(BroadComponent);
